import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { RecipesTab } from '@/features/recipes/recipes-tab';

// S12 · Recipes + viewer + test run (07 §4). `?v=` the version shown, `?run=` a test read to follow live.
export const Route = createFileRoute('/_app/carriers/$code/recipes')({
  validateSearch: z.object({ v: z.number().int().optional(), run: z.string().optional() }),
  component: RecipesTab,
});
